import { typeColor, rootDarkColor, standardColor, darkModeColor, brandColor, COLORS } from "./palette";

const { standard, darkMode } = typeColor



let standardPalette = {
    colors: standardColor,
    mode: 'light',
    background: {
        default: "#fafafa"
    },
    text: {
        default: standard.default
    },
    textColor: standard.default,
    primary: {
        main: standard.action,
    },
    secondary: {
        main: standard.secondary,
    },
    textPrimary: {
        main: standard.action
    }
}

let darkModePalette = {
    type: 'dark',
    mode: 'dark',
    colors: darkModeColor,
    text: {
        default: darkMode.default
    },
    background: {
        default: rootDarkColor
    },    
    textColor: darkMode.default,
    primary: {
        main: darkMode.action,
    },
    secondary: {
        main: darkMode.secondary,
    },
    textPrimary: {
        main: darkMode.action
    }
}

standardPalette.brand = brandColor
darkModePalette.brand = brandColor

standardPalette.rows = {
    even: "rgba(0, 0, 0, 0.04)",
    odd: "rgba(0, 0, 0, 0.12)"
}
darkModePalette.rows = {
    even: "rgba(255, 255, 255, 0.08)",
    odd: "rgba(255, 255, 255, 0.12)"
}

standardPalette.constants = COLORS
darkModePalette.constants = COLORS

export { standardPalette, darkModePalette }